// Spec 083 — a CADEIA entre linhas de produção.
//
// A ligação é SOLTA: nenhuma regra de produção, ordem, simulação, apuração ou alarme a consulta.
// Ela existe para o relatório poder mostrar duas etapas no mesmo período e comparar o que uma
// entrega com o que a outra diz consumir (FR-050).
//
// Não há entidade "cadeia" a nomear: uma cadeia é o COMPONENTE CONEXO das ligações, e o rótulo é a
// sequência das linhas. É por isso que nenhum schema aqui tem nome editável.
import { z } from "zod";
import { UuidSchema } from "./common.js";

export const LineChainStageSchema = z.object({
  lineId: UuidSchema,
  lineName: z.string(),
  /** Nível topológico: 0 para etapa sem origem dentro da cadeia. */
  level: z.number().int().nonnegative(),
  /**
   * As linhas que alimentam esta DIRETAMENTE. Vem do grafo porque não é derivável da ordem: as
   * etapas saem em ordem topológica, e nela duas etapas vizinhas podem não ter ligação (fan-in) e
   * uma ligação real pode pular etapas (uma linha de nível 0 que alimenta só a última).
   */
  upstreamLineIds: z.array(UuidSchema),
});
export type LineChainStage = z.infer<typeof LineChainStageSchema>;

export const LineChainSchema = z.object({
  /**
   * Identificador ESTÁVEL da cadeia: o id da linha de menor nível, desempate pelo nome. Não é
   * chave de tabela — a cadeia não tem tabela. É o que permite ao seletor guardar a escolha na URL
   * sem inventar uma entidade.
   */
  id: UuidSchema,
  /** "Debulhagem → Descasque". Derivado da sequência, nunca digitado. */
  label: z.string(),
  stages: z.array(LineChainStageSchema).min(2),
});
export type LineChain = z.infer<typeof LineChainSchema>;

export const LineChainListResponseSchema = z.object({ items: z.array(LineChainSchema) });
export type LineChainListResponse = z.infer<typeof LineChainListResponseSchema>;

/**
 * `:lineId` é a linha de DESTINO — a que é alimentada. É a perspectiva do cadastro, que pergunta
 * "esta linha é alimentada por quem".
 */
export const CreateChainLinkRequestSchema = z.object({ upstreamLineId: UuidSchema }).strict();
export type CreateChainLinkRequest = z.infer<typeof CreateChainLinkRequestSchema>;

export const ChainLinkParamsSchema = z.object({
  lineId: UuidSchema,
  upstreamLineId: UuidSchema,
});
export type ChainLinkParams = z.infer<typeof ChainLinkParamsSchema>;

export const LineChainLinkSchema = z.object({
  id: UuidSchema,
  upstreamLineId: UuidSchema,
  upstreamLineName: z.string(),
  downstreamLineId: UuidSchema,
  downstreamLineName: z.string(),
});
export type LineChainLink = z.infer<typeof LineChainLinkSchema>;
